import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialActivityPageState,
  ActivityItemData,
  ActivityListResponse,
  ActivityListStateType,
} from "../core/_model.activity";

export const defaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedTeam = {
  data: ActivityItemData | null;
  action: ActionsKey;
};

export type ActionedActivity = {
  data: ActivityItemData;
  action: ActionsKey;
};

type ActivityDataType = {
  activityList: any;
  detail: ActivityItemData | null;
  actioned: ActionedActivity | null;
  totalItems?: number;
  setDetail: (detail: ActivityItemData | null) => void;
  setActivityList: (roles: ActivityListResponse | null) => void;
  setActioned: (act: ActionedTeam | null) => void;
  pageState: any;
  setPageState: (state: any) => void;
  resetPageState: () => void;
};

export const useActivityStore = create<ActivityDataType>(
  (set) => ({
    activityList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: defaultPageState,
    setDetail: (detail) => set((state) => ({ detail })),
    setActivityList: (activityData) =>
      set(() => ({
        activityList: activityData?.member,
        totalItems: activityData?.totalItems ?? 0,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);

export const useActivityListState = create<ActivityListStateType>(
  (set) => ({
    pageState: initialActivityPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);